import React, {useState, useEffect} from 'react';
import {Outlet, useNavigate} from 'react-router-dom';
import {logout} from '../services/authServices';
import Sidebar from "./sidebar/index";
import AppTopBar from "./AppTopBar";

const Layout = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/login')
    };

    const [sidebarMobile, setSidebarMobile] = useState(false);
    const [sidebarVisibility, setSidebarVisibility] = useState(false);
    const [sidebarCompact, setSidebarCompact] = useState(false);

    useEffect(() => {
        sidebarVisibility ? document.body.classList.add('overflow-hidden') : document.body.classList.remove('overflow-hidden');
    }, [sidebarVisibility])


    useEffect(() => {
        const handleMobileSidebar = () => {
            if (window.innerWidth < 1200) {
                setSidebarMobile(true);
            } else {
                setSidebarMobile(false);
                setSidebarVisibility(false)
            }
        }

        handleMobileSidebar();
        window.addEventListener('resize', handleMobileSidebar);
        return () => {
            window.removeEventListener('resize', handleMobileSidebar);
        };
    }, []);

    return (
        <div className="min-h-screen bg-[#f4f6f9]">
            <Sidebar
                mobile={sidebarMobile}
                visibility={sidebarVisibility}
                setVisibility={setSidebarVisibility}
                compact={sidebarCompact}
                setCompact={setSidebarCompact}
                onLogout={handleLogout}
            />
            <div
                className={`flex flex-col min-h-screen min-w-0 transition-[margin-left] duration-300 ease-out ${
                    sidebarCompact ? 'xl:ml-[72px]' : 'xl:ml-[260px]'
                }`}
            >
                <AppTopBar
                    siteTitle={process.env.REACT_APP_SITE_TITLE}
                    showMobileMenu={sidebarMobile}
                    onMobileMenuOpen={() => setSidebarVisibility(true)}
                    onCompactToggle={() => setSidebarCompact(!sidebarCompact)}
                    isCompact={sidebarCompact}
                    onLogout={handleLogout}
                />
                <main className="flex-1 min-w-0 overflow-x-hidden overflow-y-auto">
                    <Outlet />
                </main>
            </div>
        </div>
    )
}

export {Layout}
